//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../no/Builder.js";
let d=[[[0,"CollisionCheck",1,0],[0,"GougeChecking",1,0],[0,"MaximumDiameter",1,0],[0,"MaximumDiameterEnabled",1,0],[0,"MinimumDiameter",1,0],[0,"MinimumDiameterEnabled",1,0],[0,"NonCuttingCollisionCheck",1,0],[0,"UseOperationSetsLibraryOnly",1,0]],[[["nOperations"],"CreateOperations",{R_:{operations:"CAM.Operation[]"}},0,0],[["faces"],"SetFaces",{},1,0],[["type"],"SetDirectionFilterType",{},1,0],[["axis"],"SetAxisDirections",{},1,0],[["basePt","axis"],"SetAccessDirection",{},2,0],[["focalPoint"],"SetFocalPoint",{},1,0],[["tolerance"],"SetAngularTolerance",{},1,0],[["nFeatures"],"GetNewFeatures",{R_:{features:"CAM.CAMFeature[]"}},0,0],[["nGroups"],"GetNewFeatureGroups",{R_:{groups:"CAM.FeatureGeometryGroup[]"}},0,0],[["nFeatures"],"GetUnmachinedFeatures",{R_:{features:"CAM.CAMFeature[]"}},0,0]],[]];
SPLM.CAM.AutomaticHoleMachining = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.AutomaticHoleMachining";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.CAM.AutomaticHoleMachining.DirectionFilterType = Object.freeze({
    "None" : "None", "ByVectors" : "ByVectors", "AwayFromPoint" : "AwayFromPoint", "TowardsPoint" : "TowardsPoint", "AwayFromAxis" : "AwayFromAxis", "TowardsAxis" : "TowardsAxis"});

export default SPLM;